if (!customElements.get('collection-sort-by')) {
  customElements.define(
    'collection-sort-by',
    class CollectionSortBy extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.state = {
          isOpen: false,
        }
      }

      connectedCallback () {
        this.setupListeners()
      }

      setupListeners () {
        super.setupListeners()

        this.els.trigger.element.addEventListener(
          'click',
          this.toggleMenu.bind(this),
        )
      }

      toggleMenu (event) {
        this.isOpen = !this.isOpen
      }

      get isOpen () {
        return this.state.isOpen
      }

      set isOpen (value) {
        this.state.isOpen = value
        this.els.menu.element.setAttribute('aria-expanded', value)
      }
    },
  )
}
